"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = Card;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react2 = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    padding: ", ";\n    display: flex;\n    width: 100%;\n    align-items: flex-end;\n    justify-content: space-between;\n    align-self: flex-end;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 0;\n    margin-bottom: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: 600;\n    line-height: ", ";  \n    margin-top: ", ";\n    margin-bottom: ", "; \n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", "; \n    font-weight: bold;\n    line-height: ", "; \n    color: ", ";\n    margin-top: 0; \n    margin-bottom: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: ", ";\n    padding-bottom: ", ";\n    line-height: ", ";    \n    margin-bottom: 0;\n    color: ", "; \n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    z-index: 2;\n    background: ", ";\n    font-family: ", ";\n    box-shadow: 0 5px 15px rgba(0,0,0,.5);\n    position: relative;\n    min-width: 514px;    \n    display: flex;\n    flex-wrap: wrap; \n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CardWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.colorObj;
}, function (props) {
  return props.fontFamilyObj;
});

var CardBodyWrapper = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.spacingObj.padding * 3 + "px";
}, function (props) {
  return props.noSubtitle && props.noBody ? props.spacingObj.padding * 7 + "px" : props.noBody ? "0px" : props.spacingObj.padding * 3 + "px";
}, function (props) {
  return props.spacingObj.padding * 4 + "px";
}, function (props) {
  return props.colorObj;
});

var HeaderWrapper = _styledComponents["default"].h1(_templateObject3(), function (props) {
  return props.spacingObj.headerFontSize + "rem";
}, function (props) {
  return props.spacingObj.padding * 4 + "px";
}, function (props) {
  return props.colorObj;
}, function (props) {
  return props.hasBodyNoSubtitle ? props.spacingObj.margin * 4 + "px" : "0";
});

var SubtitleWrapper = _styledComponents["default"].h2(_templateObject4(), function (props) {
  return props.colorObj;
}, function (props) {
  return props.spacingObj.subtitleFontSize + "rem";
}, function (props) {
  return props.spacingObj.padding * 4 + "px";
}, function (props) {
  return props.subtitleOnly ? "0px" : props.spacingObj.margin * 0.75 + "px";
}, function (props) {
  return props.hasBody ? props.spacingObj.margin * 4.5 + "px" : "0px";
});

var OverlineWrapper = (0, _styledComponents["default"])(SubtitleWrapper)(_templateObject5(), function (props) {
  return props.spacingObj.margin + "px";
});

var CardFooterWrapper = _styledComponents["default"].div(_templateObject6(), function (props) {
  return props.spacingObj.padding * 3 + "px";
});
/**
 * Cards contain content and actions about a single subject.
 * @example import { Card } from '@desktop/react';
 */


function Card(props) {
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var colors = context.getColors()[props.inherit][props.type];
  var spacing = context.getSpacing()[props.inherit];
  var buttonType = props.type === "secondary" ? "outlined" : "primary";
  var iconColor = props.type === "secondary" ? "white" : "#8E8E8E";
  var buttonArray = [];
  var iconArray = [];
  props.items.map(function (item, keyNum) {
    var itemPadding = spacing.margin * 3 + "px";
    var buttonStyle = {
      margin: "0px",
      marginRight: props.itemOrder === "reverse" ? itemPadding : "0",
      marginLeft: props.itemOrder === "reverse" ? "0" : itemPadding
    };
    var iconStyle = {
      margin: "0px",
      marginRight: props.itemOrder === "reverse" ? "0" : itemPadding,
      marginLeft: props.itemOrder === "reverse" ? itemPadding : "0"
    };

    if (item.props.type === "button") {
      var newStyle = _objectSpread(_objectSpread({}, buttonStyle), item.props.style);

      buttonArray.push( /*#__PURE__*/_react["default"].createElement(_react2.Button, {
        key: "button" + keyNum,
        onClick: item.props.onClick,
        type: buttonType,
        style: newStyle,
        disabled: item.props.disabled,
        icon: item.props.icon,
        dense: item.props.dense
      }, item.props.children));
    } else if (item.props.type === "icon") {
      var _newStyle = _objectSpread(_objectSpread({}, iconStyle), item.props.style);

      iconArray.push( /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
        iconid: item.props.label,
        key: "icon" + keyNum,
        size: "medium",
        onClick: item.props.onClick,
        color: item.props.color ? item.props.color : iconColor,
        basestyle: _newStyle
      }));
    }
  });
  return /*#__PURE__*/_react["default"].createElement(CardWrapper, {
    onClick: props.onClick,
    className: "Card " + props.className,
    fontFamilyObj: context.getFont(),
    colorObj: colors.backgroundColor,
    style: props.style
  }, /*#__PURE__*/_react["default"].createElement(CardBodyWrapper, {
    key: "card_body",
    colorObj: colors.textColor,
    spacingObj: spacing,
    style: props.bodyStyle,
    noBody: !props.children,
    noSubtitle: !props.subtitle
  }, props.overline ? /*#__PURE__*/_react["default"].createElement(OverlineWrapper, {
    key: "card_overline",
    colorObj: colors.textColor,
    spacingObj: spacing
  }, props.overline) : null, props.title ? /*#__PURE__*/_react["default"].createElement(HeaderWrapper, {
    key: "card_header",
    colorObj: colors.titleColor,
    spacingObj: spacing,
    hasBodyNoSubtitle: props.children && !props.subtitle,
    style: props.headerStyle
  }, props.title) : null, props.subtitle ? /*#__PURE__*/_react["default"].createElement(SubtitleWrapper, {
    key: "card_subtitle",
    hasBody: props.children,
    spacingObj: spacing,
    colorObj: colors.textColor,
    style: props.subtitleStyle,
    subtitleOnly: !(props.title || props.overline)
  }, props.subtitle) : null, props.children), /*#__PURE__*/_react["default"].createElement(CardFooterWrapper, {
    key: "card_footer",
    spacingObj: spacing,
    style: props.footerStyle
  }, props.actions && props.actions, /*#__PURE__*/_react["default"].createElement("div", null, props.itemOrder === 'reverse' ? buttonArray : iconArray), /*#__PURE__*/_react["default"].createElement("div", null, props.itemOrder === 'reverse' ? iconArray : buttonArray)));
}

Card.propTypes = {
  /**The content displayed in the body of the card. */
  children: _propTypes["default"].node,

  /**REVISIT THIS */
  items: _propTypes["default"].array,

  /**REVISIT THIS */
  itemOrder: _propTypes["default"].string,

  /**Defines the styling of the card. The types are: default, primary, and secondary. */
  type: _propTypes["default"].string,

  /**Content to be displayed in the header of the Card element. */
  title: _propTypes["default"].node,

  /**Content to display in the header of the Card element below the title. */
  subtitle: _propTypes["default"].node,

  /**Content to display in the header of the Card element above the title. */
  overline: _propTypes["default"].node,

  /**Extends the base styling of the Card element. */
  style: _propTypes["default"].object,

  /**Extends the base styling of the Card header. */
  headerStyle: _propTypes["default"].object,

  /**Extends the base styling of the Card subtitle. */
  subtitleStyle: _propTypes["default"].object,

  /**Extends the base styling of the Card overline. */
  overlineStyle: _propTypes["default"].object,

  /**Extends the base styling of the Card footer. */
  footerStyle: _propTypes["default"].object
};
Card.defaultProps = {
  style: {},
  headerStyle: {},
  subtitleStyle: {},
  overlineStyle: {},
  footerStyle: {},
  bodyStyle: {},
  type: 'default',
  title: null,
  subtitle: null,
  overline: null,
  className: "",
  inherit: 'card',
  items: [],
  itemOrder: "default",
  onClick: function onClick() {
    return false;
  },
  actions: null
};